// extracted by mini-css-extract-plugin
export default {"supportSectionContainer":"SupportSection_supportSectionContainer__Qj2hB","strokedIcon":"SupportSection_strokedIcon__RD1OO","filledIcon":"SupportSection_filledIcon__LeA7O"};